import React, { useEffect, useRef, useState } from 'react';
import { axiosInstance } from '../../client';

const isLocalUrl = (url) => url.startsWith('blob:') || url.startsWith('data:');

function SecurePdfViewer({ fileUrl, title }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let objectUrl;
    let cancelled = false;

    setBlobUrl(null);
    setError(false);

    if (!fileUrl) return;

    // Archivo recién seleccionado: ya es una URL local, no se descarga
    if (isLocalUrl(fileUrl)) {
      setBlobUrl(fileUrl);
      return;
    }

    axiosInstance.get(fileUrl, { responseType: 'blob' })
      .then(response => {
        if (cancelled) return;
        const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
        objectUrl = URL.createObjectURL(pdfBlob);
        setBlobUrl(objectUrl);
      })
      .catch(err => {
        console.error('Error al cargar PDF:', err);
        if (!cancelled) setError(true);
      });

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [fileUrl]);

  if (error) {
    return (
      <div className="p-8 text-center text-gray-500 font-itcbook">
        El archivo no existe.
      </div>
    );
  }

  if (!blobUrl) {
    return (
      <div className="flex items-center justify-center w-full h-[500px] rounded border">
        <svg className="w-8 h-8 text-blue-600 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
        </svg>
      </div>
    );
  }

  return (
    <iframe
      src={blobUrl}
      title={title}
      className="w-full h-[500px] rounded border"
    />
  );
}

const DropArea = ({
  accept,
  selectedFile,
  onDrop,
  onChange,
  icon,
  text,
  preventDefaults,
  previewUrl,
  setPreviewUrl,
  inputRef
}) => {
  const previewRef = useRef(null);

  useEffect(() => {
    if (selectedFile instanceof File) {
      const url = URL.createObjectURL(selectedFile);
      setPreviewUrl(url);
      return () => URL.revokeObjectURL(url);
    }

  }, [selectedFile, setPreviewUrl]);

  const getContentType = () => {
    if (previewUrl) {
      const url = previewUrl.toLowerCase();

      if (url.includes('.pdf') ||
        (selectedFile instanceof File && selectedFile.type === 'application/pdf')) {
        return 'pdf';

      } else if (url.includes('.mp4') || url.includes('.mov') || url.includes('.webm') || url.includes('.ogg') ||
        (selectedFile instanceof File && selectedFile.type.startsWith('video/'))) {
        return 'video';

      } else if (url.includes('.gif') ||
        (selectedFile instanceof File && selectedFile.type === 'image/gif')) {
        return 'image';
      } else {
        return 'image';
      }
    }
    return null;
  };

  const contentType = getContentType();
  const isPdf = contentType === 'pdf';
  const isVideo = contentType === 'video';
  const isImage = contentType === 'image';

  const handleClick = e => {
    if (previewRef.current && previewRef.current.contains(e.target) && !(!isPdf && !isVideo && !isImage)) {
      return;
    }
    inputRef.current?.click();
  };

  return (
    <div
      onClick={handleClick}
      onDrop={onDrop}
      onDragOver={preventDefaults}
      onDragEnter={preventDefaults}
      onDragLeave={preventDefaults}
      className={`
        w-full border border-dashed rounded-lg
        p-6 bg-white relative min-h-[200px] border-gray-400
        cursor-pointer flex flex-col items-center text-center
        ${previewUrl ? 'justify-start' : 'justify-center'}
      `}
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={onChange}
        className="hidden"
      />

      <div className="flex flex-col items-center">
        {icon}
        <span className="mt-2 text-sm font-itcbook">{text}</span>
      </div>


      {previewUrl && (
        <div
          ref={previewRef}
          className="flex justify-center w-full mt-6"
        >
          {/* <iframe
              src={previewUrl}
              title="PDF Preview"
              className="w-full h-[400px] border rounded"
            /> */}
          {isPdf ? (
            <SecurePdfViewer fileUrl={previewUrl} title={"PDF Preview"} />

          ) : isVideo ? (
            <video
              src={previewUrl}
              controls
              className="object-contain w-auto max-h-[400px] rounded"
            />
          ) : (
            <img
              src={previewUrl}
              alt="Vista previa"
              className="object-contain w-auto max-h-[400px] rounded"
              onError={(e) => {
                console.error('Error cargando imagen:', previewUrl);
                e.target.style.display = 'none';
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default DropArea;